import { Config } from 'modules/config/state/config-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { Dedication } from '../../../../models/Dedication'

export const makeOrderDedicationInitialState = (
  config: Config,
  urlParams: URLParams,
): Dedication => {
  const dedicationValue = urlParams.dedication ?? ''
  const [firstName, ...restName] = dedicationValue.split(' ') || []
  // set all the other names as the last name
  const lastName = restName.join(' ')

  return {
    hasDedication: config.dedication.isEnabled,
    type: 'honor',
    honoreeFirstName: firstName,
    honoreeLastName: lastName,
    honoreeName: `${firstName} ${lastName}`.trim(),
    recipientFirstName: '',
    recipientLastName: '',
    recipientName: '',
    recipientEmailAddress: '',
    recipientAddress: '',
    recipientCity: '',
    recipientState: '',
    recipientPostalCode: '',
    recipientCountry: '',
    isGiftAmountMessageIncluded: false,
    ecardMessage: '',
  }
}
